/**
 * Before/after comparisons in article Markdown:
 *
 *   :::vergleich
 *   ![DOMEA](/media/ab/ab12....png)
 *   ![eGov-Suite](/media/cd/cd34....png)
 *   :::
 *
 * The first picture is revealed on the left, the second on the right, and a
 * slider moves the border (components/ImageCompare.js). "compare" works as
 * well as "vergleich". A block without two pictures is shown as ordinary
 * text; fenced code blocks are left alone.
 */

const OPEN = /^\s*:::\s*(vergleich|compare)\s*$/i;
const CLOSE = /^\s*:::\s*$/;
const FENCE = /^\s*(```|~~~)/;
const IMAGE = /!\[([^\]]*)\]\(\s*([^)\s]+)(?:\s+"[^"]*")?\s*\)/g;

/** Splits Markdown into { type: 'markdown', text } and { type: 'compare', images: [{ alt, src }] }. */
export function splitCompareBlocks(markdown = '') {
  const lines = markdown.split(/\r?\n/);
  const segments = [];
  let buffer = [];
  let block = null;
  let inFence = false;

  function flushText() {
    if (buffer.length) {
      segments.push({ type: 'markdown', text: buffer.join('\n') });
      buffer = [];
    }
  }

  for (const line of lines) {
    if (!block && FENCE.test(line)) {
      inFence = !inFence;
    }

    if (!inFence && !block && OPEN.test(line)) {
      block = [];
      continue;
    }

    if (block && CLOSE.test(line)) {
      const body = block.join('\n');
      const images = Array.from(body.matchAll(IMAGE)).map((m) => ({ alt: m[1].trim(), src: m[2] }));

      if (images.length >= 2) {
        flushText();
        segments.push({ type: 'compare', images: images.slice(0, 2) });
      } else {
        buffer.push(body);
      }

      block = null;
      continue;
    }

    (block ?? buffer).push(line);
  }

  // An unclosed block is just text.
  if (block) {
    buffer.push(...block);
  }

  flushText();
  return segments;
}
